import { Cardio, Tailspin } from "ldrs/react";
import "ldrs/react/Cardio.css";
import "ldrs/react/Tailspin.css";

type SpinnerProps = {
  size?: number | string;
  color?: string;
  speed?: number | string;
  stroke?: number | string;
};

// `currentColor` inherits the surrounding text color, which contrasts with
// any background by construction (a button on `bg-primary` has
// `text-primary-foreground`, etc.). Callers can still override with
// `color={...}` for non-button contexts.
const COMMON = { size: "16", color: "currentColor", stroke: "2" } as const;

export function Spinner(props: SpinnerProps) {
  return <Tailspin {...COMMON} speed="0.9" {...props} />;
}

// CardioSpinner is decorative (heartbeat shape, never inside a button), so it
// defaults to the primary theme color rather than inheriting `currentColor`
// from a `text-muted-foreground` container.
export function CardioSpinner(props: SpinnerProps) {
  return <Cardio {...COMMON} color="var(--primary)" speed="2" {...props} />;
}
